import fetchQuery from 'rebook/apps/utils/fetchQuery';
import {
  PAGES_STATIC_PAGE_SET_DATA,
  PAGES_STATIC_PAGE_RESET_DATA,
} from 'rebook/apps/pages/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


export function fetchInitialData(match) {
  return async(dispatch, getState) => {
    const currentState = getState().staticPage;
    // do not request extra content if already prerendered
    if (!currentState.content) {
      await dispatch(fetchPage(match));
    }
  };
}

export function fetchPage(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const pageName = match.params.page || 'about';
    const url =`/api/static-page/?name=${pageName}`;
    // clear the page content before the fetch
    dispatch(resetData());
    return fetchQuery(url, { headers: ssr.headers })
      .then(
        ({ data }) => {
          dispatch(setData({
            title: data.title,
            content: data.content,
            pageName,
          }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to load static page due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load static page due to server error');
        }
      );
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { title, pageName } = getState().staticPage;
    const metaTitle = `${pageName !== 'about' ? `${title} — ` : ''}О книжном клубе — MyBook`;
    const ogTags = [
      { name: 'title', value: metaTitle },
    ];
    const canonicalUrl = pageName === 'about'
      ? `https://${BASE_HOST}/about/`
      : `https://${BASE_HOST}/about/${pageName}/`;
    dispatch(SeoActions.setData({
      title: metaTitle,
      canonicalUrl,
      ogTags,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    dispatch({
      type: PAGES_STATIC_PAGE_SET_DATA,
      payload,
    });
    dispatch(setSeoMeta());
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: PAGES_STATIC_PAGE_RESET_DATA,
    });
  };
}
